import { render } from "./StorePricingConfig.vue?vue&type=template&id=40297a2c&scoped=true"
import script from "./StorePricingConfig.vue?vue&type=script&lang=js"
export * from "./StorePricingConfig.vue?vue&type=script&lang=js"

import "./StorePricingConfig.vue?vue&type=style&index=0&id=40297a2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40297a2c"]])

export default __exports__